module.exports = __webpack_public_path__ + "media/images/woocommerce-white-fa446bc10429ecdf79dd2ef409dce062.png";